import { HsHypersceneConstants } from '../../math-new/constants/hyperscene-constants.global';
import { HsVector3 } from '../../math-new/objects/vector3.class';
import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGenerateConeGeometryData(quality: number = 12, bottomCap: boolean = true): HsRegularGeometryData {
  const up: number = 1;
  const down: number = 0;
  const vertices: number[] = [];
  const normals: number[] = [];
  const capVertices: number[] = [];
  const capNormals: number[] = [];
  const normalVector: HsVector3 = HsVector3.makeUnitVectorX();
  for (let i: number = 0; i < quality; i++) {
    const angle0: number = (i / quality) * HsHypersceneConstants.PI_MUL_2;
    const angle1: number = ((i + 1) / quality) * HsHypersceneConstants.PI_MUL_2;
    const x0: number = Math.cos(angle0);
    const x1: number = Math.cos(angle1);
    const z0: number = Math.sin(angle0);
    const z1: number = Math.sin(angle1);
    vertices.push(x0, down, z0, x1, down, z1, 0, up, 0);
    normalVector.set(x0, Math.SQRT1_2, z0).normalize();
    normals.push(...normalVector.values);
    normalVector.set(x1, Math.SQRT1_2, z1).normalize();
    normals.push(...normalVector.values);
    normalVector.set(0, Math.SQRT1_2, 0).normalize();
    normals.push(...normalVector.values);
    if (bottomCap) {
      capVertices.push(x1, down, z1, x0, down, z0, 0, down, 0);
      capNormals.push(0, -1, 0, 0, -1, 0, 0, -1, 0);
    }
  }
  vertices.push(...capVertices);
  normals.push(...capNormals);
  return new HsRegularGeometryData(vertices, normals);
}
